import { CodeError } from '@iotize/common/error';

import { BLEPacketBuilder } from './ble-packet-builder';

export class BleComError extends CodeError<BleComError.Code> {
  static invalidBleChunkChecksum(packetBuilder: BLEPacketBuilder) {
    return InvalidBleFrameChecksum.create(packetBuilder);
  }
  static writeSizeAboveMTU(data: Uint8Array, mtu: number) {
    return new BleComError(
      BleComError.Code.BleWriteSizeAboveMTU,
      `Cannot write ${data.length} bytes as it's more than the Maximal Transfert Unit (${mtu})`,
    );
  }

  public static serviceNotFound(uuid: string) {
    return new BleComError(
      BleComError.Code.BleGattServiceNotFound,
      `Bluetooth service with id ${uuid} not found`,
    );
  }

  public static charcacteristicNotFound(uuid: string) {
    return new BleComError(
      BleComError.Code.BleGattCharacteristicNotFound,
      `Bluetooth characteristic with id ${uuid} not found`,
    );
  }

  public static bleNotAvailable(
    msg: string = 'BLE is not available on your device',
  ) {
    return new BleComError(BleComError.Code.NotAvailable, msg);
  }

  static gattServerNotAvailable() {
    return new BleComError(
      BleComError.Code.GATTServerNotAvailable,
      `Generic Attribute Profile (GATT) server is not available`,
    );
  }

  static gattServerConnectionFailed() {
    return new BleComError(
      BleComError.Code.GATTServerConnectionFailed,
      `Gatt server connection failed`,
    );
  }

  constructor(code: BleComError.Code, msg: string) {
    super(msg, code);
  }
}

export class InvalidBleFrameChecksum extends BleComError {
  constructor(public packetBuilder: BLEPacketBuilder) {
    super(BleComError.Code.InvalidChecksum, `Invalid checksum`);
  }
  static create(packetBuilder: BLEPacketBuilder) {
    return new InvalidBleFrameChecksum(packetBuilder);
  }
}

export namespace BleComError {
  export enum Code {
    InvalidChecksum = 'InvalidChecksum',
    BleGattServiceNotFound = 'BleGattServiceNotFound',
    BleGattCharacteristicNotFound = 'BleGattCharacteristicNotFound',
    BleWriteSizeAboveMTU = 'BleWriteSizeAboveMTU',
    GATTServerNotAvailable = 'BleComErrorGATTServerNotAvailable',
    GATTServerConnectionFailed = 'BleComErrorGATTServerConnectionFailed',
    NotAvailable = 'BleComErrorNotAvailable',
  }
}
